<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div id="maincontent" class="main page-about-us" rel="main" info-json-data="">
			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link"  @click="goHome">
								<a >Home</a>
							</li>
							<li class="nav-link">
								<span>About Us</span>
							</li>
						</ul>

					</div>
				</div>
			</div>



			<div class="headline-module background-image background-image-desktop background-image-desktop2">
				<div class="page-header">
					<div class="page-wrapper">
						<div class="infographic-module">
							<div class="infographic-content" style="display: block;">
								<div class="infographic-content-wrapper">
									<div class="firm-number">
										<sup v-if="circleData[itemIndex-1].type == 1">#</sup>{{circleData[itemIndex-1].number}}
									</div>
									<div class="firm-title">{{circleData[itemIndex-1].title}}</div>
									<div class="firm-tag">{{circleData[itemIndex-1].tag[0]}}<br> {{circleData[itemIndex-1].tag[1]}} <br>
										{{circleData[itemIndex-1].tag[2]}}</div>
								</div>
							</div>
							<div class="infographic-nav">
								<button class="infographic-nav-btn" :class="itemIndex == 1 ? 'is-active' : ''" data-siteimprove-feature="keyfact"
									aria-label="Law Firm Brand" data-siteimprove-title="Law Firm Brand"
									data-siteimprove-custom=""></button>
								<button class="infographic-nav-btn" :class="itemIndex == 2 ? 'is-active' : ''" data-siteimprove-feature="keyfact" aria-label="Law"
									data-siteimprove-title="Law" data-siteimprove-custom=""></button>
								<button class="infographic-nav-btn" :class="itemIndex == 3 ? 'is-active' : ''" data-siteimprove-feature="keyfact"
									aria-label="Advancing Equity" data-siteimprove-title="Advancing Equity"
									data-siteimprove-custom=""></button>
								<button class="infographic-nav-btn" :class="itemIndex == 4 ? 'is-active' : ''" data-siteimprove-feature="keyfact"
									aria-label="Sustainability" data-siteimprove-title="Sustainability"
									data-siteimprove-custom=""></button>
								<button class="infographic-nav-btn" :class="itemIndex == 5 ? 'is-active' : ''" data-siteimprove-feature="keyfact"
									aria-label="Outside Counsel Diversity Awards"
									data-siteimprove-title="Outside Counsel Diversity Awards"
									data-siteimprove-custom=""></button>
								<button class="infographic-nav-btn" :class="itemIndex == 6 ? 'is-active' : ''" data-siteimprove-feature="keyfact"
									aria-label="Cross-Border Deals" data-siteimprove-title="Cross-Border Deals"
									data-siteimprove-custom=""></button>
								<button class="infographic-nav-btn" :class="itemIndex == 7 ? 'is-active' : ''" data-siteimprove-feature="keyfact"
									aria-label="Lawyer Rankings " data-siteimprove-title="Lawyer Rankings "
									data-siteimprove-custom=""></button>
							</div>
							<!-- SVG Closing tags for Path elements get striped by kickstart, cant use handlebars to populate images references -->
							<div class="infographic">
								<!-- SVG Menu Generated By CIRCULUS.SVG :: http://sarasoueidan.com/tools/circulus -->
								<svg style="transform-origin: 50% 50% 0px; transform:  matrix3d(0.440974, -0.89752, 0, 0, 0.89752, 0.440974, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); -moz-user-select: none;"
									xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"
									viewBox="-25 -25 554 554" id="svgWheel" data-timer-delay="4000">
									<!-- Dropshadow filter for white circle -->
									<filter id="dropShadow">
										<feGaussianBlur in="SourceAlpha" stdDeviation="2"></feGaussianBlur>
										<feOffset dx="-1" dy="1"></feOffset>
										<feMerge>
											<feMergeNode></feMergeNode>
											<feMergeNode in="SourceGraphic"></feMergeNode>
										</feMerge>
									</filter>
									<!-- Image Thumbnails -->
									<!-- Adjust the rotate and scale values to position the images; rotate(deg, y, x) -->

									<defs>
										<pattern id="imgItem1" x="0" y="0" width="1" height="1">
											<image transform="rotate(68, 70, 65) scale(.9)" width="264" height="183"
												xmlns:xlink="http://www.w3.org/1999/xlink"
												:xlink:href="require('../../assets/test/92.webp')">
											</image>
										</pattern>
									</defs>
									<defs>
										<pattern id="imgItem7" x="0" y="0" width="1" height="1">
											<image transform="rotate(116, 95, 108) scale(0.9)" width="236" height="242"
												:xlink:href="require('../../assets/test/93.webp')">
											</image>
										</pattern>
									</defs>
									<defs>
										<pattern id="imgItem6" x="0" y="0" width="1" height="1">
											<image transform="rotate(168, 77, 115) scale(1)" width="195" height="247"
												:xlink:href="require('../../assets/test/94.webp')">
											</image>
										</pattern>
									</defs>
									<defs>
										<pattern id="imgItem5" x="0" y="0" width="1" height="1">
											<image transform="rotate(-142, 117, 115) scale(1)" width="238" height="195"
												:xlink:href="require('../../assets/test/95.webp')">
											</image>
										</pattern>
									</defs>
									<defs>
										<pattern id="imgItem4" x="0" y="0" width="1" height="1">
											<image transform="rotate(-90, 94, 120) scale(1)" width="224" height="213"
												:xlink:href="require('../../assets/test/96.webp')">
											</image>
										</pattern>
									</defs>
									<defs>
										<pattern id="imgItem3" x="0" y="0" width="1" height="1">
											<image transform="rotate(-43, 60, 130) scale(1.2)" width="182" height="259"
												:xlink:href="require('../../assets/test/97.webp')">
											</image>
										</pattern>
									</defs>
									<defs>
										<pattern id="imgItem2" x="0" y="0" width="1" height="1">
											<image transform="rotate(12, 75, 0) scale(0.9)" width="234" height="233"
												:xlink:href="require('../../assets/test/98.webp')">
											</image>
										</pattern>
									</defs>

									<!-- Paths for each pie slide -->
									<g id="itemsContainer">

										<a data-svg-origin="250 250" :transform="'matrix('+item1matrix[0]+','+item1matrix[1]+','+item1matrix[2]+','+item1matrix[3]+','+item1matrix[4]+','+item1matrix[5]+')'"
											tabindex="0" role="link" id="item-1" class="svg-item" :class="itemIndex == 1 ? 'active' : ''"
											data-siteimprove-feature="keyfact" data-siteimprove-title="Law Firm Brand"
											aria-label="Law Firm Brand" data-siteimprove-custom="" href="javascript:;" @click="SelctItem(1)">
											<path class="img"
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="url(#imgItem1)"></path>
											<path class="sector "
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="none"></path>
										</a>

										<a data-svg-origin="250.0035133260862 249.9996041192436"
											:transform="'matrix('+item2matrix[0]+','+item2matrix[1]+','+item2matrix[2]+','+item2matrix[3]+','+item2matrix[4]+','+item2matrix[5]+')'"
											xlink:href=" " tabindex="0" role="link" id="item-2" class="svg-item" :class="itemIndex == 2 ? 'active' : ''"
											data-siteimprove-feature="keyfact" data-siteimprove-title="Law"
											aria-label="Law" data-siteimprove-custom="" href="javascript:;" @click="SelctItem(2)">
											<path class="img"
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="url(#imgItem2)"></path>
											<path class="sector "
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="none"></path>
										</a>

										<a data-svg-origin="250.00210243730936 250.00157158089888"
											:transform="'matrix('+item3matrix[0]+','+item3matrix[1]+','+item3matrix[2]+','+item3matrix[3]+','+item3matrix[4]+','+item3matrix[5]+')'"
											xlink:href=" " tabindex="0" role="link" id="item-3" class="svg-item" :class="itemIndex == 3 ? 'active' : ''"
											data-siteimprove-feature="keyfact" data-siteimprove-title="Advancing Equity"
											aria-label="Advancing Equity" data-siteimprove-custom="" href="javascript:;" @click="SelctItem(3)">
											<path class="img"
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="url(#imgItem3)"></path>
											<path class="sector "
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="none"></path>
										</a>

										<a data-svg-origin="250.00226904362 250.00220264234355"
											:transform="'matrix('+item4matrix[0]+','+item4matrix[1]+','+item4matrix[2]+','+item4matrix[3]+','+item4matrix[4]+','+item4matrix[5]+')'"
											xlink:href=" " tabindex="0" role="link" id="item-4" class="svg-item" :class="itemIndex == 4 ? 'active' : ''"
											data-siteimprove-feature="keyfact" data-siteimprove-title="Sustainability"
											aria-label="Sustainability" data-siteimprove-custom="" href="javascript:;" @click="SelctItem(4)">
											<path class="img"
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="url(#imgItem4)"></path>
											<path class="sector "
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="none"></path>
										</a>

										<a data-svg-origin="250.00220264234355 250.00226904362"
											:transform="'matrix('+item5matrix[0]+','+item5matrix[1]+','+item5matrix[2]+','+item5matrix[3]+','+item5matrix[4]+','+item5matrix[5]+')'"
											xlink:href=" " tabindex="0" role="link" id="item-5" class="svg-item" href="javascript:;" :class="itemIndex == 5 ? 'active' : ''"
											data-siteimprove-feature="keyfact"
											data-siteimprove-title="Outside Counsel Diversity Awards"
											aria-label="Outside Counsel Diversity Awards" data-siteimprove-custom=""
											@click="SelctItem(5)">
											<path class="img"
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="url(#imgItem5)"></path>
											<path class="sector "
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="none"></path>
										</a>

										<a data-svg-origin="250.00157158089888 250.00210243730936"
											:transform="'matrix('+item6matrix[0]+','+item6matrix[1]+','+item6matrix[2]+','+item6matrix[3]+','+item6matrix[4]+','+item6matrix[5]+')'"
											xlink:href=" " tabindex="0" role="link" id="item-6" class="svg-item" href="javascript:;" :class="itemIndex == 6 ? 'active' : ''"
											data-siteimprove-feature="keyfact"
											data-siteimprove-title="Cross-Border Deals" aria-label="Cross-Border Deals"
											data-siteimprove-custom="" @click="SelctItem(6)">
											<path class="img"
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="url(#imgItem6)"></path>
											<path class="sector "
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111"></path>
										</a>

										<a data-svg-origin="249.9996041192436 250.0035133260862"
											:transform="'matrix('+item7matrix[0]+','+item7matrix[1]+','+item7matrix[2]+','+item7matrix[3]+','+item7matrix[4]+','+item7matrix[5]+')'"
											xlink:href=" " tabindex="0" role="link" id="item-7" class="svg-item " href="javascript:;" :class="itemIndex == 7 ? 'active' : ''"
											data-siteimprove-feature="keyfact" data-siteimprove-title="Lawyer Rankings "
											aria-label="Lawyer Rankings " data-siteimprove-custom="" @click="SelctItem(7)">
											<path class="img"
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="url(#imgItem7)"></path>
											<path class="sector "
												d="M385,250 l115,0 A250,250 0 0,0 405.8724504646834,54.542129382992584 l-71.70132721375438,89.91062048382341 A135,135 0 0,1 385,250"
												stroke="#111" fill="none"></path>
										</a>
									</g>


									<!-- white Circle -->
									<g transform="matrix(1,0,0,1,190,190)" id="circleContent">
										<circle data-svg-origin="250 250" cx="60" cy="60" r="150" fill="#fff"
											filter="url(#dropShadow)"></circle>
									</g>

									<!-- Triangle/Arrow Positioning -->
									<g :transform="'matrix('+matrixVal[0]+','+matrixVal[1]+','+matrixVal[2]+','+matrixVal[3]+','+matrixVal[4]+','+matrixVal[5]+')'"
										id="svg-arrow" data-svg-origin="59.997031444945016 60.00942274778748"
										style="transform-origin: 0px 0px 0px;">
										<circle data-svg-origin="250 250" cx="60" cy="60" r="150" fill="none"></circle>
										<polyline transform="matrix(1,0,0,1,40,-110)" points="10,32  40,32  25,2  10,32"
											style="fill: #fff;"></polyline>
									</g>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div class="sticky-arrow"></div>
			</div>
			<div class="orderable-modules">
				<div data-module-id="overviewModule" class="csr-module js-overview-expand">
					<div data-scroll-up="true" class="csr-committee overview-full description js-overview-full" v-if="leadershipSta" >
						<div
							class="contact-module csr-contacts-hidden js-contact-module contact-module-default-bg contact-module-center">
							<div class="button-expand-wrapper csr page-wrapper">
								<div class="firm-row">
									<h3 class="header">Global Chair</h3>
									<ul class="main-contacts">
										<li class="contact-information" >
											<a class="professional-tile">
												<div class="content">
													<figure class="profile-image">
														<img :src="LeaderList[0].img">
													</figure>
													<div class="profile">
														<h3 class="name">{{LeaderList[0].name}}</h3>

														<div class="title">Global Chair</div>

														<ul class="locations">
															<li class="location">
																{{LeaderList[0].location}}
															</li>
														</ul>
														<div class="bottom">
															<div class="contact">
																<span class="phone">{{LeaderList[0].phone}}</span>
																<span class="contact-link-url email"><span class="iconfont icon-email"></span>Email</span>
															</div>

														</div>
													</div>
												</div>
											</a>
										</li>
									</ul>
								</div>
								<div class="firm-row">
									<h3 class="header">Executive Committee</h3>
									<ul class="main-contacts">
										<li class="contact-information" v-for="(item, index) in LeaderList.slice(1)">
											<a class="professional-tile">
												<div class="content">
													<figure class="profile-image">
														<img :src="item.img">
													</figure>
													<div class="profile">
														<h3 class="name">{{item.name}}</h3>
														<div class="title">{{item.title}}</div>

														<ul class="locations">
															<li class="location">
																{{item.location}}
															</li>
														</ul>
														<div class="bottom">
															<div class="contact">
																<span class="phone">{{item.phone}}</span>
																<span class="contact-link-url email"><span class="iconfont icon-email"></span>Email</span>
															</div>
														</div>
													</div>
												</div>
											</a>
										</li>
									</ul>
								</div>
								<div class="firm-row">
									<h3 class="header">International Management</h3>
									<ul class="main-contacts">
										<li class="contact-information" v-for="(item,index) in InternationalmanagementList">
											<div class="professional-tile not-linked">
												<div class="content">
													<figure class="profile-image">
														<img :src="item.img">
													</figure>
													<div class="profile">
														<h3 class="name">{{item.name}}</h3>

														<div class="title">{{item.title}}</div>
														<div class="bottom">
															<div class="contact">
																<span class="phone">{{item.phone}}</span>
																<span class="contact-link-url email"><span class="iconfont icon-email"></span>Email</span>
															</div>

														</div>
													</div>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="csr-trigger">
						<button @click="showLeadership" class="button-red button-medium csr-button-expand js-overview-trigger"
							data-siteimprove-feature="firmcontacts" data-siteimprove-title="View Firm Leadership"
							data-siteimprove-custom="">View Firm Leadership</button>
					</div>
				</div>
				<div class="global-module global-module-page-wrapper">
					<div class="page-wrapper">
						<h2 class="module-header">About Baker McKenzie</h2>
						<ul class="page-subcategories">
							<li class="subcategory"><a class="subcategory-link">Inclusion, Diversity &amp; Equity</a>
							</li>
							<li class="subcategory"><a class="subcategory-link">Sustainability</a></li>
							<li class="subcategory"><a class="subcategory-link">Pro Bono</a>
							</li>
							<li class="subcategory"><a class="subcategory-link">People
									Deal</a></li>
							<li class="subcategory"><a class="subcategory-link">Code of Business Conduct</a></li>
						</ul>
						<div class="description rte">
							<p>Baker McKenzie brings insight and foresight to clients across more than 70 global
								offices. Our team of 13,000 people, including over 6,500 lawyers and tax professionals,
								works alongside our clients to drive growth that is both sustainable – and inclusive.
							</p>
							<p style="text-align: left;"><span style="text-align: left;">The global business community
									is more interconnected than ever before. Opportunities and risks spill across
									different markets, sectors and areas of law, so a connected perspective is essential
									in delivering business objectives while mitigating risk. Our integrated client
									solutions provide seamless advice, underpinned by deep practice and sector
									expertise, as well as first-rate local market knowledge.</span></p>
							
						</div>
					</div>
				</div>

				<div class="related-content global-module">
					<div class="articles-related-module js-articles-related-module featured-insights">
						<div class="featured-insights__collection js-article-list" data-child-selector="4">
							<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image pcm-standard-background-image2">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label">Insight | Podcast</div>
												<div class="content-headline">Solutions for a Connected World Podcast
													Series</div>
												<div class="content-summary">This podcast series spans across markets,
													sectors and areas of laws to uncover forward-looking insights from
													Baker McKenzie and industry experts on driving growth in your
													organization.</div>
											</div>
										</div>
									</div>
								</a>
							</div>


							<div class="featured-insights__tile promo-content-tile ">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="container-row">
											<div class="content">
												<div class="content-type-label">News | Firm News</div>
												<div class="content-headline">Baker McKenzie Announces Global Revenues
													of USD $3.3 Billion</div>
												<div class="content-summary">Our revenues of USD $3.3 billion for the
													fiscal year ended 30 June 2023 are up 2.5% on a currency neutral
													basis. &nbsp;</div>
											</div>
										</div>
									</div>
								</a>
							</div>


							<div class="featured-insights__tile promo-content-tile ">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="container-row">
											<div class="content">
												<div class="content-type-label">News | Firm News</div>
												<div class="content-headline">Baker McKenzie Releases Annual
													Sustainability Report 2023</div>
												<div class="content-summary">We have continued to make progress on our
													sustainability-related objectives.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile view-all-placeholder">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="container-row">
											<button class="button-red">View All News</button>
										</div>
									</div>

								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile view-all-placeholder">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="container-row">
											<button class="button-red">View All Insight</button>
										</div>
									</div>
								</a>
							</div>

						</div>
						<button data-label-expand="View All" data-label-collapse="View Less"
							class="button-red button-expand js-button-expand">View All</button>
					</div>
				</div>
				<div class="global-module global-module-page-wrapper-with-image">
					<figure class="header-section-hero">
						<img alt="" class="image-full" src="../../assets/test/20.webp">
						<!-- <img alt="" class="image-mobile"
							src="/-/media/redesign/bm_careers_1440pxw_300pxh.jpg?rev=4b9d09e68ce640cabe526c19dd9327ee&amp;sc_lang=en"> -->
					</figure>
					<div class="page-wrapper">
						<div class="section-header-wrapper">
							<h2 class="section-header">
								Looking for a career at Baker McKenzie?
							</h2>
						</div>

						<div class="description rte">
							<p>We are different from other law firms in the way we think, work and behave. We want
								individuals who can combine an impressive academic track record with excellent technical
								skills. Personal qualities matter — we look for engaged global citizens, critical
								thinkers and problem solvers.</p>
						</div>
						<div class="callout-link"> <a @click="toPage('/careers')"
								class="button-red">Learn More</a> </div>
					</div>
				</div>

			</div>

		</div>
		<footer class="global-footer">
			<div class="communication-footer hide-print">
				<ul class="social-links">
					<li class="social-link"><a class="bm bm-linkedin" aria-label="Baker McKenzie LinkedIn "></a></li>
					<li class="social-link"><a class="bm bm-twitter" aria-label="Baker McKenzie Twitter"></a></li>
					<li class="social-link"><a class="bm bm-facebook" aria-label="Baker McKenzie Facebook "></a></li>
					<li class="social-link"><a class="bm bm-youtube" aria-label="Baker McKenzie YouTube"></a></li>
					<li class="social-link"><a class="bm bm-we-chat" aria-label="Baker McKenzie WeChat"></a></li>
					<li class="social-link"><a class="bm bm-rss" aria-label="Baker McKenzie RSS"></a></li>
				</ul>
			</div>
			<div class="footer-nav hide-print">
				<ul class="utility-links">
					<li class="utility-link"><a>Disclaimers</a></li>
					<li class="utility-link"><a>Privacy &amp; Cookies Statement</a></li>
					<li class="utility-link"><a title="Manage Choices">Cookie Preferences</a></li>
					<li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
					<li class="utility-link"><a>Contact Us</a></li>
					<li class="utility-link"><a>Media Contacts</a></li>
					<li class="utility-link"><a>Blogs</a></li>
					<li class="utility-link"><a>BM Online</a></li>
				</ul>
		
			</div>
			<div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>
			</div>
		</footer>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
				leadershipSta:false,
				LeaderList:[
					{
						name:'Milton W. M. Cheng',
						img:require('../../assets/test/11.webp'),
						title:'Global Chair',
						location:'Hong Kong',
						phone:'+ 852 2846 1056',
						email:'w.com'
					},
					{
						name:'Gustavo A. Boruchowicz',
						img:require('../../assets/test/12.webp'),
						title:'Partner',
						location:'Buenos Aires',
						phone:'+ 54 11 4310 2271',
						email:'w.com'
					},
					{
						name:'Anders Fast',
						img:require('../../assets/test/13.webp'),
						title:'Partner',
						location:'Stockholm',
						phone:'+ 46 8 56617792',
						email:'w.com'
					},
					{
						name:'Shih Yann Loo',
						img:require('../../assets/test/14.webp'),
						title:'Partner',
						location:'Hong Kong',
						phone:'+ 852 2846 1727',
						email:'w.com'
					},
					{
						name:'Melinda R. Phelan',
						img:require('../../assets/test/15.jpeg'),
						title:'Partner',
						location:'Dallas',
						phone:'+ 1 214 965 7061',
						email:'w.com'
					},
				],
				InternationalmanagementList:[
					{
						name:'Peter J. Engstrom',
						img:require('../../assets/test/16.webp'),
						title:'General Counsel',
						phone:'+1 415 576 3025',
						email:'w.com'
					},
					{
						name:'Marredia Crawford',
						img:require('../../assets/test/17.webp'),
						title:'Chief Inclusion, Diversity & Equity Officer',
						phone:'+ 1 713 236 5171',
						email:'w.com'
					},
					{
						name:'Alyssa Auberger',
						img:require('../../assets/test/18.webp'),
						title:'Chief Sustainability Officer',
						phone:'+ 1 214 965 7061',
						email:'w.com'
					}
				],
				matrixVal:[0,0,0,0,0,0],
				matrixVal1:[0.43837,0.89879,-0.89879,0.43837,278.10668934693877,169.70687233236012],
				matrixVal2:[-0.42938,0.90312,-0.90312,-0.42938,330.30089744391717,221.9151338186444],
				matrixVal3:[-0.9738,0.22737,-0.22737,-0.9738,322.0241361811298,295.27149388605983],
				matrixVal4:[-0.78493,-0.61958,0.61958,-0.78493,259.51188156269507,334.5379646743053],
				matrixVal5:[-0.00498,-0.99998,0.99998,-0.00498,189.8359048330792,310.14512110341053],
				matrixVal6:[0.77871,-0.62738,0.62738,0.77871,165.4643578116623,240.4614416621835],
				matrixVal7:[0.97602,0.21765,-0.21765,0.97602,204.7510713542393,177.9599460226516],
				itemIndex:1,
				isClickItem:false,
				item1matrix:[1,0,0,1,0,0],
				item1matrixO:[1,0,0,1,0,0],
				item1matrixS:[1.1,0,0,1.1,-25,-25],
				item2matrix:[0.62348,0.78183,-0.78183,0.62348,289.5852877999434,-101.33255431992173],
				item2matrixO:[0.62348,0.78183,-0.78183,0.62348,289.5852877999434,-101.33255431992173],
				item2matrixS:[0.68583,0.86001,-0.86001,0.68583,293.54381657993764,-136.46580975191387],
				item3matrix:[-0.22252,0.97492,-0.97492,-0.22252,549.3643714541978,61.896809915867486],
				item3matrixO:[-0.22252,0.97492,-0.97492,-0.22252,549.3643714541978,61.896809915867486],
				item3matrixS:[-0.24477,1.07242,-1.07242,-0.24477,579.3008085996177,43.08649090745424],
				item4matrix:[-0.90096,0.43388,-0.43388,-0.90096,583.7162076956047,366.77212241903504],
				item4matrixO:[-0.90096,0.43388,-0.43388,-0.90096,583.7162076956047,366.77212241903504],
				item4matrixS:[-0.99106,0.47727,-0.47727,-0.99106,617.0878284651651,378.44933466093863],
				item5matrix:[-0.90096,-0.43388,0.43388,-0.90096,366.77212241903504,583.7162076956047],
				item5matrixO:[-0.90096,-0.43388,0.43388,-0.90096,366.77212241903504,583.7162076956047],
				item5matrixS:[-0.99106,-0.47727,0.47727,-0.99106,378.44933466093863,617.0878284651651],
				item6matrix:[-0.22252,-0.97492,0.97492,-0.22252,61.896809915867486,549.3643714541978],
				item6matrixO:[-0.22252,-0.97492,0.97492,-0.22252,61.896809915867486,549.3643714541978],
				item6matrixS:[-0.24477,-1.07242,1.07242,-0.24477,43.08649090745424,579.3008085996177],
				item7matrix:[0.62348,-0.78183,0.78183,0.62348,-101.33255431992173,289.5852877999434],
				item7matrixO:[0.62348,-0.78183,0.78183,0.62348,-101.33255431992173,289.5852877999434],
				item7matrixS:[0.68583,-0.86001,0.86001,0.68583,-136.46580975191387,293.54381657993764],
				circleData:[{
					'type':1,
					'number':1,
					'title':'Law Firm Brand',
					'tag':['World’s strongest law firm','brand for 12 years running','(Thomson Reuters)']
				},{
					'type':2,
					'number':'Reinvent',
					'title':'Law',
					'tag':['Launched AI collaboration','with SparkBeyond to','reimagine legal industry']
				},{
					'type':2,
					'number':'40:40:20',
					'title':'Advancing Equity',
					'tag':['Progressing equitable','opportunity with global aspirational gender targets','for Firm leadership']
				},{
					'type':2,
					'number':'92%',
					'title':'Sustainability',
					'tag':['Global Scope 1 and 2 carbon','emissions reduction target by','2030 (against a 2018 baseline)']
				},{
					'type':2,
					'number':'Inclusion',
					'title':'Outside Counsel Diversity Awards',
					'tag':['Recognized by Accenture','and other clients for our','market-leading ID&E efforts']
				},{
					'type':2,
					'number':'65%',
					'title':'Cross-Border Deals',
					'tag':['Nearly two-thirds of revenues','come where we act for clients','in 5 or more countries']
				},{
					'type':2,
					'number':'447',
					'title':'Lawyer Rankings',
					'tag':['Top 3 for number of','lawyers ranked globally','(Chambers Global)']
				}],
				isInit:true,
				timer:null,
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
			if(this.isClickItem){
				this.setMatrix()
			}else{
				this.autoSetMatrix()
			}
			
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
			if (this.timer) {
			  clearInterval(this.timer);
			}
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			goHome() {
				this.$router.replace('/');
			},
			showLeadership(){
				this.leadershipSta = !this.leadershipSta
			},
			toPage(path){
				this.$router.replace(path); 
			},
			autoSetMatrix(){
				this.setMatrix()
				this.timer = setInterval(() => {
				    if(this.itemIndex < 7){
						this.itemIndex = this.itemIndex + 1
				    }else{
						this.itemIndex = 1
				    }
				    this.setMatrix()
				}, 1500);
			},
			setMatrix(){
				switch (this.itemIndex){
					case 1:
						this.item1matrix = this.item1matrixS
						this.item2matrix = this.item2matrixO
						this.item3matrix = this.item3matrixO
						this.item4matrix = this.item4matrixO
						this.item5matrix = this.item5matrixO
						this.item6matrix = this.item6matrixO
						this.item7matrix = this.item7matrixO
						this.matrixVal = this.matrixVal1
						break;
					case 2:
						this.item2matrix = this.item2matrixS
						this.item1matrix = this.item1matrixO
						this.item3matrix = this.item3matrixO
						this.item4matrix = this.item4matrixO
						this.item5matrix = this.item5matrixO
						this.item6matrix = this.item6matrixO
						this.item7matrix = this.item7matrixO
						this.matrixVal = this.matrixVal2
						break;
					case 3:
						this.item3matrix = this.item3matrixS
						this.item2matrix = this.item2matrixO
						this.item1matrix = this.item1matrixO
						this.item4matrix = this.item4matrixO
						this.item5matrix = this.item5matrixO
						this.item6matrix = this.item6matrixO
						this.item7matrix = this.item7matrixO
						this.matrixVal = this.matrixVal3
						break;
					case 4:
						this.item4matrix = this.item4matrixS
						this.item2matrix = this.item2matrixO
						this.item3matrix = this.item3matrixO
						this.item1matrix = this.item1matrixO
						this.item5matrix = this.item5matrixO
						this.item6matrix = this.item6matrixO
						this.item7matrix = this.item7matrixO
						this.matrixVal = this.matrixVal4
						break;
					case 5:
						this.item5matrix = this.item5matrixS
						this.item2matrix = this.item2matrixO
						this.item3matrix = this.item3matrixO
						this.item4matrix = this.item4matrixO
						this.item1matrix = this.item1matrixO
						this.item6matrix = this.item6matrixO
						this.item7matrix = this.item7matrixO
						this.matrixVal = this.matrixVal5
						break;
					case 6:
						this.item6matrix = this.item6matrixS
						this.item2matrix = this.item2matrixO
						this.item3matrix = this.item3matrixO
						this.item4matrix = this.item4matrixO
						this.item5matrix = this.item5matrixO
						this.item1matrix = this.item1matrixO
						this.item7matrix = this.item7matrixO
						this.matrixVal = this.matrixVal6
						break;
					case 7:
						this.item7matrix = this.item7matrixS
						this.item2matrix = this.item2matrixO
						this.item3matrix = this.item3matrixO
						this.item4matrix = this.item4matrixO
						this.item5matrix = this.item5matrixO
						this.item6matrix = this.item6matrixO
						this.item1matrix = this.item1matrixO
						this.matrixVal = this.matrixVal7
						break;
					default:
						this.item1matrix = this.item1matrixS
						this.item2matrix = this.item2matrixO
						this.item3matrix = this.item3matrixO
						this.item4matrix = this.item4matrixO
						this.item5matrix = this.item5matrixO
						this.item6matrix = this.item6matrixO
						this.item7matrix = this.item7matrixO
						this.matrixVal = this.matrixVal1
						break;
				}
			},
			SelctItem(e){
				this.itemIndex = e
				if (this.timer) {
				  clearInterval(this.timer);
				}
				this.setMatrix()
			}
		}
	}
</script>

<style src="@/assets/main.css" scoped></style>
<style lang='scss' scoped>
	.body-container {
		width: 100%;
		/* min-width: 1280px; */
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.main {
		padding-top: 82px;
	}
	.background-image-desktop2 {
		background-image: url('../../assets/test/91.jpeg');
	}
	.icon-email {
		margin-right: 5px;
	}
	.pcm-standard-background-image2 {
		background: url('../../assets/test/52.webp') no-repeat;
		background-size: cover;
	}
	@media screen and (max-width: 47.9375em){
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.main {
			padding-top: 63px;
		}
		.promo-content-tile.promo-content-tile--has-image .promo-content-link .container-row {
		    margin: 0 20px;
		    padding: 15px;
		    bottom: -14px;
		    width: calc(87% - 40px);
		}
	}
</style>
